import { TenantOrderContext } from '~/tenants/common/TenantOrderContext';

export function context_has_buyer<O extends TenantOrderContext>(
  order: O,
  field: keyof O['buyer']['metadata'],
): boolean {
  // TODO: fix typing
  // @ts-ignore
  return Boolean(order.parent?.[field] ?? order.buyer.metadata[field]);
}

export function context_get_performable<
  O extends TenantOrderContext,
  P extends O['jobs'][0]['performable_id'],
  J extends Extract<O['jobs'][0], { performable_id: P }>,
>(order: O, id: P): J | undefined {
  return order.jobs.find((j) => j.performable_id === id) as J;
}

export function context_has_performable<
  O extends TenantOrderContext,
  P extends O['jobs'][0]['performable_id'],
  M extends Extract<O['jobs'][0], { performable_id: P }>['metadata'],
>(order: O, id: P, metadata: Partial<M> = {}) {
  return order.jobs.some((j) => {
    if (j.performable_id !== id) {
      return false;
    }

    if (metadata) {
      for (const key in metadata) {
        if (j.metadata[key] !== metadata[key]) {
          return false;
        }
      }
    }

    return true;
  });
}
